import { bianka, BIANKA_ACTIVITY_TYPES } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { Impression } from '@fiverr-private/bianka_js';
import { PAGE_NAME } from './onBiankaImpression.constants';

export const buildBaseImpressionEnrichment = ({ eventType, pageName = PAGE_NAME, componentName }) => {
    const { pageCtxId, userId, userGuid, isTouch } = getContext();

    const event = {
        group: 'components_impressions',
        type: eventType,
        page: {
            name: pageName,
            ctxId: pageCtxId,
            component: { name: componentName },
        },
    };

    const rootImpressionData = {
        pageName,
        type: BIANKA_ACTIVITY_TYPES.IMPRESSION,
        uid: userGuid,
        contextId: pageCtxId,
        platform: isTouch ? 'MOBILE_WEB' : 'WEB',
        ...(userId && { user: { id: userId } }),
    };

    return { rootImpressionData, event };
};

export const onBiankaImpression = async ({ eventData }) => {
    const { eventType, pageName, componentName, ...component } = eventData;
    const { rootImpressionData, event } = buildBaseImpressionEnrichment({
        eventType,
        pageName,
        componentName,
    });

    const {
        imp_id,
        level,
        is_leaf,
        position_in_parent,
        size_in_parent,
        visible_through_scroll,
        parent_component_imp_id,
    } = component;

    const eventPayload = {
        ...rootImpressionData,
        event: {
            ...event,
            component: {
                impId: imp_id,
                level,
                isLeaf: is_leaf,
                positionInParent: position_in_parent,
                sizeInParent: size_in_parent,
                visibleThroughScroll: visible_through_scroll,
                name: componentName,
                parentComponentImpId: parent_component_imp_id,
            },
        },
    };

    bianka.reportActivity<Impression>(eventPayload);
};

export const onImpression = (eventData) => {
    onBiankaImpression({ eventData });
};
